import {UseFormRegister, UseFormSetValue} from "react-hook-form";
import {
    useDownloadAccountFile,
    useReadBillSelectBox,
    useReadCustomerCategorySelect,
    useReadCustomerTypeSelect,
    useReadIndustrySelectBox,
    useReadLocationSelectBox,
    useReadReceiptTypeSelectBox,
} from "../hooks";
import {BasicClientInfoType, UploadedFile} from "../interface";
import {useModal} from "../../../../../hooks";
import FileUploadWithText from "../../../../../components/common/fileUpload/fileUploadWithText/FileUploadWithText";
import {SearchErpInner} from "../../../../../components/common/modal/inner/SearchErpInner";
import {SearchBusinessPartnerInner} from "../../../../../components/common/modal/inner/SearchBusinessPartnerInner";
import {useEffect} from "react";
import useFileUpload from "../../../../../components/common/fileUpload/fileUploadWithText/hooks/useFileUpload";

type Props = {
    basicInfoData: BasicClientInfoType | null | undefined;
    register: UseFormRegister<BasicClientInfoType>;
    mode: string;
    watchesBasicInfo?: BasicClientInfoType;
    setValue?: UseFormSetValue<BasicClientInfoType>;
    setFile?: React.Dispatch<React.SetStateAction<File | null>>;
};

/**
 * 기본정보 탭
 * @param props
 * @returns
 */
export const BasicTab = ({
                             basicInfoData,
                             register,
                             mode,
                             watchesBasicInfo,
                             setFile,
                             setValue,
                         }: Props) => {
    const {data: billSelectData} = useReadBillSelectBox();
    const {data: customerTypeData} = useReadCustomerTypeSelect();
    const {data: industrySelect} = useReadIndustrySelectBox();
    const {data: customerCategorySelect} = useReadCustomerCategorySelect();
    const {data: locationSelect} = useReadLocationSelectBox();
    const {data: receiptTypeSelect} = useReadReceiptTypeSelectBox();
    const {mutate: downloadFileMutate} = useDownloadAccountFile();

    const {
        fileRef,
        files,
        handleButtonClick,
        handleChange,
        deleteFile,
        deleteUpdatedFile,
        setFiles,
    } = useFileUpload({
        uploadedFiles: basicInfoData?.businessFileInfo
            ? [basicInfoData.businessFileInfo as UploadedFile]
            : [],
        isMulti: false,
    });

    const {handleModal, resetModal} = useModal();

    useEffect(() => {
        // 취소 눌렀을때
        if (mode === "R") {
            setFiles(
                basicInfoData?.businessFileInfo
                    ? [basicInfoData.businessFileInfo as UploadedFile]
                    : []
            );
        }
    }, [mode, basicInfoData?.businessFileInfo]);

    // useEffect(() => {
    //     if (watchesBasicInfo?.name && setValue) {
    //         setValue("name", watchesBasicInfo?.name.replace(" ", ""))
    //     }
    // }, [watchesBasicInfo?.name]);

    const handleFilesChange = (files: File[]) => {
        if (setFile) {
            if (files[0]) {
                setFile(files[0]);
            } else {
                setFile(null);
            }
        }
    };

    return (
        <div className="content_wrap">
            <h5 className="subheading mt-0">회사정보</h5>
            <div className="table_scroll mb-0">
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                    <tr>
                        <th style={{width: "16.66%"}}>회사명(국문) {mode !== "R" && <span className="required">*</span>}</th>
                        <td style={{width: "33.34%"}} className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                basicInfoData?.name ?? ""
                            ) : (
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register("name")}
                                    // onInput={(e) => {
                                    //     const input = e.target as HTMLInputElement;
                                    //     input.value = input.value.replace(/\s/g, "");
                                    // }}
                                />
                            )}
                        </td>
                        <th style={{width: "16.66%"}}>상위거래처</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                basicInfoData?.parentAccount
                            ) : (
                                <div className="d-flex">
                                    <input
                                        type="text"
                                        className="form-control"
                                        {...register("parentAccount")}
                                        disabled
                                    />
                                    <button
                                        className="btn btn-info btn_search ms-5px"
                                        onClick={() =>
                                            handleModal({
                                                isOpen: true,
                                                contents: (
                                                    <SearchBusinessPartnerInner
                                                        confirmCallback={(item) => {
                                                            if (setValue) {
                                                                setValue(
                                                                    "parentAccountIdValue",
                                                                    item?.accountId,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                setValue("parentAccount", item?.name, {
                                                                    shouldDirty: true,
                                                                });
                                                            }
                                                        }}
                                                        modalDepth={1}
                                                    />
                                                ),
                                                type: "",
                                                title: "상위 거래처 조회",
                                                modalSize: "xxl",
                                            })
                                        }
                                    >
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/icon_search.png"
                                            }
                                            alt=""
                                        />
                                        찾기
                                    </button>
                                </div>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>회사명(영문)</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                basicInfoData?.newTxtNameEng ?? ""
                            ) : (
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register("newTxtNameEng")}
                                />
                            )}
                        </td>
                        <th>업체관계</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                customerTypeData?.map((item) => {
                                    if (item?.id === basicInfoData?.newPCustomerType) {
                                        return <>{item?.name}</>;
                                    }
                                })
                            ) : (
                                <select
                                    className="form-select"
                                    {...register("newPCustomerType")}
                                >
                                    <option value={0}>선택</option>
                                    {customerTypeData?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>소속분류 {mode !== "R" && <span className="required">*</span>}</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                customerCategorySelect?.map((item) => {
                                    if (item?.id === basicInfoData?.newPCustomerCategory) {
                                        return <>{item?.name}</>;
                                    }
                                })
                            ) : (
                                <select
                                    className="form-select"
                                    {...register("newPCustomerCategory")}
                                >
                                    <option value={0}>선택</option>
                                    {customerCategorySelect?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                            )}
                        </td>
                        <th>소재지</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                locationSelect?.map((item) => {
                                    if (item?.id === basicInfoData?.newPLocation) {
                                        return <>{item?.name}</>;
                                    }
                                })
                            ) : (
                                <select className="form-select" {...register("newPLocation")}>
                                    <option value={0}>선택</option>
                                    {locationSelect?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>산업구분</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                industrySelect?.map((item) => {
                                    if (item?.id === basicInfoData?.newLIndustryGlobalValue) {
                                        return <>{item?.name}</>;
                                    }
                                })
                            ) : (
                                <select
                                    className="form-select"
                                    {...register("newLIndustryGlobalValue")}
                                >
                                    <option value={""}>선택</option>
                                    {industrySelect?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                            )}
                        </td>
                        <th>티어정보</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                basicInfoData?.tierInfo
                            ) : (
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register("tierInfo")}
                                />
                            )}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h5 className="subheading mt-20px">ERP 거래처정보</h5>
            <div className="table_scroll mb-0">
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                    <tr>
                        <th style={{width: "16.66%"}}>ERP 코드</th>
                        <td style={{width: "33.34%"}}>
                            {mode === "R"
                                ? basicInfoData?.newTxtCdPartner
                                : watchesBasicInfo?.newTxtCdPartner}
                        </td>
                        <th style={{width: "16.66%"}}>수금방법</th>
                        <td>
                            {billSelectData?.map((item) => {
                                if (
                                    mode === "R"
                                        ? item?.id === basicInfoData?.newPFgBill
                                        : item?.id === watchesBasicInfo?.newPFgBill
                                ) {
                                    return <>{item?.name}</>;
                                }
                            })}
                        </td>
                    </tr>
                    <tr>
                        <th>ERP 거래처</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                basicInfoData?.newTxtNmPartner
                            ) : (
                                <div className="d-flex">
                                    <input
                                        type="text"
                                        className="form-control"
                                        {...register("newTxtNmPartner")}
                                        disabled
                                    />
                                    <button
                                        className="btn btn-info btn_search ms-5px"
                                        onClick={() =>
                                            handleModal({
                                                isOpen: true,
                                                contents: (
                                                    <SearchErpInner
                                                        confirmCallback={(item) => {
                                                            if (setValue) {
                                                                // ERP 코드
                                                                setValue(
                                                                    "newTxtCdPartner",
                                                                    item.newTxtCdPartner as string,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // erp 거래처 id
                                                                setValue(
                                                                    "newLAccountErpValue",
                                                                    item.new_erp_accountid as string,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // erp 거래처 이름
                                                                setValue(
                                                                    "newTxtNmPartner",
                                                                    item.new_txt_nm_partner as string,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // 수금방법
                                                                setValue(
                                                                    "newPFgBill",
                                                                    item.newPFgBill ?? null,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // 여신한도
                                                                setValue(
                                                                    "newDTotCredit",
                                                                    item.newDTotCredit ?? null,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // 대표자
                                                                setValue(
                                                                    "newTxtNmCeo",
                                                                    item.newTxtNmCeo ?? "",
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // 수금예정월
                                                                setValue(
                                                                    "newPTpRcpDd",
                                                                    item.newPTpRcpDd ?? null,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // 대표전화
                                                                setValue(
                                                                    "newTxtNoTel",
                                                                    item.newTxtNoTel ?? null,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // 수금예정일
                                                                setValue(
                                                                    "newIDtRcpDd",
                                                                    item.newIDtRcpDd ?? null,
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // 주소1
                                                                setValue(
                                                                    "newTxtDcAds1H",
                                                                    item.newTxtDcAds1H ?? "",
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );
                                                                // 주소2
                                                                setValue(
                                                                    "newTxtDcAds1D",
                                                                    item.newTxtDcAds1D ?? "",
                                                                    {
                                                                        shouldDirty: true,
                                                                    }
                                                                );

                                                                // 내부수정: 업태 종목 사업자등록번호
                                                                setValue("newTxtTpJob", item.newTxtTpJob ?? null, {shouldDirty: true});
                                                                setValue("newTxtClsJob", item.newTxtClsJob ?? null, {shouldDirty: true});
                                                                setValue("newTxtNoCompany", item.newTxtNoCompany ?? null, {shouldDirty: true});
                                                            }
                                                        }}
                                                        modalDepth={1}
                                                    />
                                                ),
                                                type: "",
                                                title: "ERP 거래처 조회",
                                                modalSize: "xl",
                                            })
                                        }
                                    >
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/icon_search.png"
                                            }
                                            alt=""
                                        />
                                        찾기
                                    </button>
                                </div>
                            )}
                        </td>
                        <th>여신한도</th>
                        <td>
                            {mode === "R"
                                ? basicInfoData?.newDTotCredit
                                : watchesBasicInfo?.newDTotCredit}
                        </td>
                    </tr>
                    <tr>
                        <th>대표자</th>
                        <td>
                            {mode === "R"
                                ? basicInfoData?.newTxtNmCeo
                                : watchesBasicInfo?.newTxtNmCeo}
                        </td>
                        <th>수금예정월</th>
                        <td>
                            {receiptTypeSelect?.map((item) => {
                                if (
                                    mode === "R"
                                        ? item?.id === basicInfoData?.newPTpRcpDd
                                        : item?.id === watchesBasicInfo?.newPTpRcpDd
                                ) {
                                    return <>{item?.name}</>;
                                }
                            })}
                        </td>
                    </tr>
                    <tr>
                        <th>대표전화</th>
                        <td>
                            {mode === "R"
                                ? basicInfoData?.newTxtNoTel
                                : watchesBasicInfo?.newTxtNoTel}
                        </td>
                        <th>수금예정일</th>
                        <td>
                            {mode === "R"
                                ? basicInfoData?.newIDtRcpDd
                                : watchesBasicInfo?.newIDtRcpDd}
                        </td>
                    </tr>
                     {/* 내부수정: 업태/종목 추가 */}
                    <tr>
                        <th>업태</th>
                        <td>
                            {mode === "R"
                                ? basicInfoData?.newTxtTpJob
                                : watchesBasicInfo?.newTxtTpJob}
                        </td>
                        <th>종목</th>
                        <td>
                            {mode === "R"
                                ? basicInfoData?.newTxtClsJob
                                : watchesBasicInfo?.newTxtClsJob}
                        </td>
                    </tr>
                    <tr>
                        <th>사업자 등록증</th>
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            <FileUploadWithText
                                mode={mode}
                                fileRef={fileRef}
                                files={files}
                                onFilesChange={handleFilesChange}
                                uploadedFiles={
                                    basicInfoData?.businessFileInfo
                                        ? [basicInfoData.businessFileInfo as UploadedFile]
                                        : []
                                }
                                downloadMutate={({data}) => {
                                    downloadFileMutate(data);
                                }}
                                handleChange={handleChange}
                                handleButtonClick={handleButtonClick}
                                deleteUpdatedFile={deleteUpdatedFile}
                                deleteFile={deleteFile}
                            />
                            {/* <button className="btn btn-link"></button> */}
                        </td>
                        <th>사업자등록번호</th>
                        {/* 내부수정: input 제거, ERP 연동값 표시로 변경 
                        <td className={mode !== "R" ? "p-4px" : ""}>
                            {mode === "R" ? (
                                basicInfoData?.businessRegNo
                            ) : (
                                <input
                                    className="form-control"
                                    {...register("businessRegNo")}
                                />
                            )}
                        </td> */}
                        <td>
                            {/* 내부수정: input 제거, ERP 연동값 표시로 변경 */}
                            {mode === "R" ? basicInfoData?.newTxtNoCompany : watchesBasicInfo?.newTxtNoCompany}
                        </td>
                    </tr>
                    <tr>
                        <th>주소1</th>
                        <td>
                            {mode === "R"
                                ? basicInfoData?.newTxtDcAds1H
                                : watchesBasicInfo?.newTxtDcAds1H}
                        </td>
                    </tr>
                    <tr>
                        <th>주소2</th>
                        <td colSpan={3}>
                            {mode === "R"
                                ? basicInfoData?.newTxtDcAds1D
                                : watchesBasicInfo?.newTxtDcAds1D}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
